module.exports = __webpack_public_path__ + "static/media/Pattern_1.f526907c.png";